/**
 * 자격 · 업종 코드표 (docs/REFACTOR.md §2).
 *
 * **분류는 판단이라 원문 인용으로 못 막는다.** 그래서 이 두 축은 enum 검사만 한다 —
 * 표에 없는 코드는 버리고 `confidence` 를 남긴다. 정의는 `hermes/prompt.md` 한 곳에
 * 있고, 여기는 코드와 화면 라벨만 둔다.
 */
/** 인증·자격 14 — 「신청할 수 있나」의 하드 필터. */
export const CERTIFICATION_CODES = [
    'venture',
    'innobiz',
    'mainbiz',
    'women',
    'disabled',
    'social',
    'small_biz',
    'youth',
    'pre_startup',
    'restart',
    'research_lab',
    'factory',
    'sme_cert',
    'lab_company',
];
export const CERTIFICATION_LABEL = {
    venture: '벤처기업',
    innobiz: '이노비즈',
    mainbiz: '메인비즈',
    women: '여성기업',
    disabled: '장애인기업',
    social: '사회적기업',
    small_biz: '소상공인',
    youth: '청년',
    pre_startup: '예비창업',
    restart: '재창업',
    research_lab: '기업부설연구소',
    factory: '공장등록',
    sme_cert: '중소기업확인서',
    lab_company: '연구소기업',
};
/**
 * 업종 — 「관련 있나」의 순위. 모델에게 **신청 기업의 업종**을 묻는다.
 * 제외 업종만 있는 공고는 전 업종(`grants.all_industries`)이다.
 */
export const INDUSTRY_CODES = [
    'manufacturing',
    'automotive',
    'machinery',
    'electronics',
    'aerospace',
    'shipbuilding',
    'chemicals',
    'energy',
    'bio',
    'medical_device',
    'food',
    'agri',
    'fashion',
    'beauty',
    'it',
    'ai',
    'game',
    'content',
    'design',
    'culture',
    'education',
    'fintech',
    'retail',
    'ecommerce',
    'logistics',
    'construction',
    'tourism',
    'service',
    'other',
];
export const INDUSTRY_LABEL = {
    manufacturing: '제조(일반)',
    automotive: '자동차·모빌리티',
    machinery: '기계·장비·로봇',
    electronics: '반도체·전기·전자',
    aerospace: '우주·항공·드론·방산',
    shipbuilding: '조선·해양',
    chemicals: '화학·소재',
    energy: '환경·에너지',
    bio: '바이오·헬스케어',
    medical_device: '의료기기',
    food: '식품·F&B',
    agri: '농수산',
    fashion: '패션·의류·섬유',
    beauty: '뷰티·화장품',
    it: 'IT·소프트웨어·통신',
    ai: 'AI·데이터',
    game: '게임',
    content: '콘텐츠·엔터·미디어',
    design: '디자인·광고·마케팅',
    culture: '문화예술·공예',
    education: '교육',
    fintech: '금융·핀테크',
    retail: '도소매·유통',
    ecommerce: '이커머스·플랫폼',
    logistics: '물류·운송',
    construction: '건설·부동산',
    tourism: '관광·여행·숙박',
    service: '서비스(기타)',
    other: '기타',
};
export const isCertificationCode = (v) => typeof v === 'string' && CERTIFICATION_CODES.includes(v);
export const isIndustryCode = (v) => typeof v === 'string' && INDUSTRY_CODES.includes(v);
export function normalizeIndustries(v) {
    const o = (v && typeof v === 'object' ? v : {});
    const raw = Array.isArray(o.list) ? o.list : [];
    const list = [...new Set(raw.filter(isIndustryCode))];
    const primary = isIndustryCode(o.primary) ? o.primary : (list[0] ?? null);
    if (primary && !list.includes(primary))
        list.unshift(primary);
    return { all: o.all === true, industries: { primary, list } };
}
//# sourceMappingURL=grant-codes.js.map